import React from "react";
import { reactApi } from "../../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { ctx as ctx_1 } from "../../Context.js";
import { map, defaultArg } from "../../fable_modules/fable-library-js.4.24.0/Option.js";
import { append, tryPick, collect } from "../../fable_modules/fable-library-js.4.24.0/Array.js";
import { collectCategories } from "../../Documents/DocumentHelpers.js";
import { documentsCtx } from "../../Documents/DocumentContext.js";
import { MuiHelpers_createElement } from "../../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { MenuItem, TextField } from "@mui/material";

export function CategorySelection(categorySelectionInputProps) {
    const onChange = categorySelectionInputProps.onChange;
    const categoryId = categorySelectionInputProps.categoryId;
    const machineId = categorySelectionInputProps.machineId;
    const ctx = reactApi.useContext(ctx_1);
    const categoryItems = defaultArg(map((array_1) => collect((categories) => collectCategories(ctx.Language, categories), array_1), tryPick((category) => {
        if (category.Machine.Id === machineId) {
            return category.Trees;
        }
        else {
            return undefined;
        }
    }, reactApi.useContext(documentsCtx).MachineCategories)), []);
    return MuiHelpers_createElement(TextField, [["key", `machine-${machineId}-category-selection`], ["id", "category-selection"], ["label", ctx.Locale.t("Document.Category")], ["select", true], ["size", "small"], ["sx", {
        flexBasis: 220 + "px",
    }], ["value", defaultArg(categoryId, "all")], ["onChange", (ev) => {
        onChange(ev.target.value);
    }], ["children", append([MuiHelpers_createElement(MenuItem, [["key", "all"], ["value", "all"], ["children", ctx.Locale.t("All")]])], categoryItems)]]);
}

